<template>
    <div>
        <img class="content-image" :src="imageSrc" v-if="imageSrc != null">
    </div>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: "ImageLoader",
        // props: ['src', 'height', 'width'],
        props: {
            src: String,
            width: {
                type: null,
                default: 1024
            },
            height: {
                type: null,
                default: 768
            }
        },
        data() {
            return {
                image: new Image(),
                imageSrc: null
            }
        },
        methods: {},
        mounted() {
            this.image.onload = () => {
                this.imageSrc = this.image.src;
                Vue.prototype.$imageCount--;
                if (Vue.prototype.$imageCount == 0) {
                    this.$preloader.hide();
                    Vue.prototype.$imageCount = 0;
                }
            };
            this.image.src = this.src;
            Vue.prototype.$imageCount++;
        }
    }
</script>

<style scoped>

</style>